import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { isEqual } from 'lodash';

import { WeightService } from '../../../entities/Weight/services';
import { WeightResponseData } from '../../../entities/Weight/interfaces';
import { getWeightRequest, getWeightSuccess, getWeightError, clearWeightState } from './actions';
import { GET_WEIGHT_REQUEST } from './constants';

function* getWeight(action: ReturnType<typeof getWeightRequest>) {
  try {
    const response: WeightResponseData = yield call(WeightService.getWeight, action.payload);

    if (isEqual(response.status, 'OK')) {
      yield put(getWeightSuccess(response.data));
    } else {
      yield put(getWeightError(Error(response.status)));
    }

    yield delay(10000);
    yield put(clearWeightState());
  } catch (error) {
    // @ts-ignore
    yield put(getWeightError(Error(error?.message || 'Помилка при отриманні ваги')));

    yield delay(10000);
    yield put(clearWeightState());
  }
}

export function* getWeightWatcher() {
  yield takeLatest(GET_WEIGHT_REQUEST, getWeight);
}
